export default "__VITE_ASSET__2ec78f15__"